import { Tr } from "@/i18n/i18n";
import { SaleIntroPanel } from "@/scenes.ui/sale-intro-panel";
import { SalePackPanel } from "@/scenes.ui/sale-pack-panel";
import { ShopCreaturePanel } from "@/scenes.ui/shop-creature-panel";
import { TabbedPanel } from "@/scenes.ui/tabbed-panel";
import { HeroShopService } from "@/services/hero-shop-service";
import { IapService } from "@/services/iap-service";
import { ListService } from "@/services/list-service";
import { PaymentChangeService } from "@/services/payment-change-service";
import { PaymentNotificationService } from "@/services/payment-notification-service";
import { ShopService, TabName } from "@/services/shop-service";
import PlayerStore from "@/store/player";
import SaleStore from "@/store/sale";
import { SaleDetails } from "@/store/sale/types";
import { IntegrationUtils } from "@/utils/integration-utils";
import ShopUtils from "@/utils/shop-utils";
import TimeUtils from "@/utils/time-utils";
import { injectable } from "inversify";
import { Scene } from "phaser";
import Container = Phaser.GameObjects.Container;

@injectable()
export class SaleService extends ShopService {

    private saleId: string | undefined = undefined;
    private static AUTOSCROLL_SPEED: number = -3.1;

    public openSale(scene: Scene, canvas: HTMLCanvasElement, noValuteFeedback: boolean, closeCallback: () => void,
                     paymentNotificationService: PaymentNotificationService, statClickCallback: (creatureId: string) => unknown,
                     tabName: TabName, listService: ListService, paymentChangeService: PaymentChangeService,
                     iapService: IapService, saleId: string) {
        this.saleId = saleId;
        this.openShop(scene, canvas, noValuteFeedback, closeCallback,
            paymentNotificationService, statClickCallback, tabName, listService, paymentChangeService, iapService);
    }

    protected createTabbedPanel(): TabbedPanel {
        let self = this;
        return new TabbedPanel(this.scene!, this.canvas!, '', ['bank', 'sale'],
            [Tr('bank'), ''], [true, true], this.selectSound, (tabId: string) => {
                if (tabId === 'bank') {
                    this.populateBankTab();
                } else if (tabId === 'sale') {
                    this.populateSaleTab();
                }
            }, () => {}, () => self.closeCallback());
    }

    protected populateSaleTab(): void {
        this.doPopulateSaleTab(false);
    }

    protected doPopulateSaleTab(re: boolean): void {
        let self = this;

        let player = PlayerStore.getPlayer()!;
        this.setupHeroAgitations(player);

        SaleStore.fetchSaleDetails(this.saleId!).then((dto: SaleDetails) => {

            self.tabbedPanel.setTabText(1, dto.name);
            self.tabbedPanel.setAgitationText(Tr('bf.welc.2'));
            self.tabbedPanel.setTitle(dto.name);

            let panels: Container[] = [];
            const userSource = player.userSource;

            let panelY = 0;

            panels.push(...HeroShopService.getTopTextsByTabId(this.scene!, this.canvas!));

            if (TimeUtils.remainSec(dto.startAt) > 0) {
                panels.push(new SaleIntroPanel(this.scene!, dto.startAt, () => {
                    if (self.scene && self.tabbedPanel.active) {
                        self.doPopulateSaleTab(true);
                    }
                }));
            }

            dto.options.forEach(bo => {

                let scp = new SalePackPanel(this.scene!, 0, panelY, bo, player, userSource, () => {
                    if (bo.price > 0) {
                        ShopUtils.buy(undefined, self.awardSound, player.userSource,
                            self.paymentNotificationService, self.iapService, self.paymentChangeService, bo, IntegrationUtils.isExternalUser());
                    }
                }, (creatureId: string) => {
                    self.listService.showManual(this.scene!, this.canvas!, creatureId, () => {});
                }, dto);

                panels.push(scp!);
                panelY += ShopCreaturePanel.HEIGHT;
            });

            // panels.push(new ChestDescPanel(this.scene!, this.canvas!));

            if (re) {
                this.tabbedPanel.resupplyChildren('sale', panels);
            } else {
                this.tabbedPanel.supplyChildren('sale', panels);
            }

            // this.tabbedPanel.setScrollSpeed(ChainService.AUTOSCROLL_SPEED * CU.S + (ChainService.AUTOSCROLL_SPEED + 1) * (dto.currentIndex - 1) * CU.S);
        });
    }


}